export const CurrencyDimensionQuery = groq`*[_type == 'personalizationDimension' && dimensionName == 'Currency'][0]`;
